export const Products = `query products($id: String, $manufacturer: String, $ids: [String], $sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {products(filter: {category_id: { eq: $id }manufacturer: { eq: $manufacturer }sku: { in: $ids }price: {from: "0.001", to: "9999999999"},is_deal_product: {eq: "0"},is_hidden_product:{eq : "0"},is_esd_product: { eq: "0"}} sort: $sort, pageSize: $pageSize, currentPage: $currentPage) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories {id name url_key image} ... on ConfigurableProduct { variants { product {id name quantity sku stock_status price_range {minimum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } maximum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } }  } attributes { label code value_index } } }  __typename price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } image { url } small_image{ url } } aggregations{ count label attribute_code options{ count label value }  } } }`;
export const Categories = `query category($id: Int){category(id: $id) { product_total_count children { position id name image product_total_count children { position id name image product_total_count }}}}`;
export const CartRecentProducts = `query products($id: String, $manufacturer: String, $ids: [String], $sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {products(filter: {category_id: { eq: $id }manufacturer: { eq: $manufacturer }sku: { in: $ids }price: {from: "0.001", to: "9999999999"},is_deal_product: {eq: "0"},is_hidden_product:{eq : "0"},is_esd_product: { eq: "0"}} sort: $sort, pageSize: $pageSize, currentPage: $currentPage) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories {id name url_key image} ... on ConfigurableProduct { variants { product {id name quantity sku stock_status price_range {minimum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } maximum_price {regular_price {value currency } final_price{value currency } discount {amount_off percent_off } } }  } attributes { label code value_index } } }  __typename ... on BundleProduct { items{ option_id options{ id } } } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } image { url } small_image{ url } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } }`;
export const ProductsByBrand = `query products( $manufacturer: String ) { products( filter: { manufacturer: { eq: $manufacturer } price: { from: "0.001", to: "9999999999" } is_deal_product: { eq: "0" } is_hidden_product: { eq: "0" } is_esd_product: { eq: "0"} }  pageSize: 6, currentPage: 1  ) { items { name quantity promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge __typename price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } } image { url } small_image { url } } } }`;

export const getCategoryCMS = `
	query getCategoryCMS($id: String!) {
		categories(filters: { ids: { in: [$id] }}) {
			items {
				cms_block {
					content
				}
				display_mode
				name
			}
		}
	}
`;

export const getProductsBySkus = `
	query getProductsBySkus($skus: [String], $pageSize: Int!) {
		products(filter: { sku: { in: $skus } }, pageSize: $pageSize) {
			items {
				id
				uid
				name
				bundle_product_price
				primary_product_image
				primary_product_sku
				manufacturer
				manufacturer_label
				price_range {
					minimum_price {
						final_price {
								currency
								value
						}
						regular_price {
								currency
								value
						}
						discount {
								amount_off
						}
					}
					maximum_price {
						final_price {
							currency
							value
						}
						regular_price {
							currency
							value
						}
						discount {
							amount_off
						}
					}
				}
				sku
				small_image {
					url
				}
				... on ConfigurableProduct {
					configurable_options {
						values {
							value_index
							swatch_data {
								value
							}
						}
					}
				}
				stock_status
				url_key
				__typename
			}
		}
	}
`;

export const getDealsProductsBySkus = `
	query getDealsProductsBySkus($skus: [String], $pageSize: Int!) {
		products(filter: { sku: { in: $skus } }, pageSize: $pageSize) {
			items {
				id
				name
				monthly_recurring
				save_monthly_recurring
				old_monthly_recurring
				payment_terms
				payment_terms_label
				primary_product_image
				primary_product_sku
				manufacturer
				manufacturer_label
				anytime_product_sku
				sku
				small_image {
					url
				}
				stock_status
				url_key
      			... on BundleProduct {
					items {
						options {
							product {
								name
								promo_data
								nightowl_units
								nightowl_uom
								minutes
								minutes_label
								attribute_set_id
								sku
							}
						}
					}
				}
				__typename
			}
		}
	}
`;

export const getCurrencySymbol = `
	query getCurrencySymbol {
		currency {
			base_currency_symbol
		}
	}
`;

export const CompareProducts = `
  query productCompare($skus: String) {
    productCompare(skus: $skus) {
      allProducts {
        name
        image
				data
				sku
      }
    }
  }
`;

export const urlResolver = `
  query urlResolver($url: String!) {
	route(url: $url) {
		__typename
		relative_url
		redirect_code
		type
		... on SimpleProduct {
		  sku
		  url_key
		  uid
		  url_rewrites {
			url
			parameters {
			  name
			  value
			}
		  }
		  relative_url
		  redirect_code
		  type
		}
  }
}
`
export const productDetailsUrl = `query products($url_key: String!) { products(filter: { url_key: { eq: $url_key } }) { items { id meta_title meta_description attribute_set_id name badges badges_swatch badges_label manufacturer stock_status stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } deal_data { product_id min_price deal_installment } quantity low_stock_threshold display_low_stock_badge manufacturer_label promotion_link promotion_tag_label sku delivery_and_return specification_data delivery_message video_preview_url video_title video_url short_description { html } description { html } battery_capacity bundle_product_price __typename general_description promotions { start_date end_date } price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } small_image { url label } media_gallery { url label position } categories { id name level } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } ... on ConfigurableProduct { deal_data { product_id min_price deal_installment } configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } product_id } variants { product { id name badges badges_label badges_swatch promotion_tag promotion_tag_swatch sku delivery_and_return front_camera secondary_camera network_4g battery_capacity stock_status quantity low_stock_threshold specification_data video_preview_url video_title video_url short_description { html } description { html } promotions { start_date end_date } promotion_link promotion_tag_label display_low_stock_badge __typename general_description image { url label } small_image { url label } thumbnail { url label } media_gallery { url label position } attribute_set_id ... on PhysicalProductInterface { weight } price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } } attributes { label code value_index } } } ... on BundleProduct { dynamic_sku dynamic_price dynamic_weight price_view ship_bundle_items items { option_id title required type position sku options { id quantity position is_default price price_type can_change_quantity label product { id name quantity low_stock_threshold display_low_stock_badge sku __typename price_range { minimum_price { regular_price { value } } } } } } } related_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } upsell_products { name sku badges badges_swatch badges_label quantity stock_status __typename low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off } } } image { url label } } crosssell_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } } } }`

export const ProductSearchList = ` query products($key: String, $id: String){ products(filter: {category_id:{eq: $id}, name: {match: $key}, is_hidden_product: {eq: "0"}}, pageSize: 200, currentPage: 1sort: {product_ranking: DESC}) { total_count page_info { page_size current_page total_pages } items { name promotion_tag_swatch badges_swatch sku badges badges_label manufacturer manufacturer_label promotion_tag_label payment_terms_label stock_status low_stock_threshold display_low_stock_badge categories{ id name url_key image } __typename description{ html } meta_title meta_description price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } price_tiers{ discount{ amount_off percent_off } final_price{ value currency } quantity } image { url label } small_image{ url label } media_gallery { url label ... on ProductVideo { video_content { media_type video_provider video_url video_title video_description video_metadata } } } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } } `;

export const ProductSearchtWithoutCategoryList = ` query products($key: String){ products(filter: {is_hidden_product: {eq: "0"}, is_deal_product: {eq: "0"}, is_esd_product: { eq: "0"}}, search: $key, pageSize: 200, currentPage: 1sort: {product_ranking: DESC}) { items { name sku categories{ id name } manufacturer manufacturer_label meta_title meta_description image { url label } small_image{ url label } } } }`;

export const FilterProducts = `query products( $filter: ProductAttributeFilterInput $sort: ProductAttributeSortInput $pageSize: Int $currentPage: Int ) { products( filter: $filter pageSize: $pageSize sort: $sort currentPage: $currentPage ) { total_count page_info { page_size current_page total_pages } items { name quantity bundle_product_price promotion_tag_swatch badges_swatch sku badges badges_label stock_status low_stock_threshold display_low_stock_badge deal_go_live_date deal_end_date deal_label is_deal_locked categories { id name url_key image } ... on ConfigurableProduct { configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } } variants { product { stock_status } } } __typename price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } } image { url } small_image { url } } aggregations { count label attribute_code options { count label value } } sort_fields { default options { label value } } } }`;

export const ProductDetails = ` query products($id: String!) { products(filter: { sku: { eq: $id } }) { items { pdp_best_features video_url id attribute_set_id deal_builder_deals name badges badges_swatch badges_label manufacturer stock_status stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } deal_data { product_id min_price deal_installment } quantity low_stock_threshold display_low_stock_badge manufacturer_label promotion_link promotion_tag_label sku delivery_and_return specification_data delivery_message video_preview_url video_title video_url short_description { html } description { html } battery_capacity bundle_product_price __typename general_description promotions { start_date end_date } price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } small_image { url label } media_gallery { url label position } categories { id name level } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } } ... on ConfigurableProduct { deal_data { product_id min_price deal_installment } configurable_options { id attribute_id label position use_default attribute_code values { value_index label swatch_data { value } } product_id } variants { product { id name deal_builder_deals badges badges_label badges_swatch promotion_tag promotion_tag_swatch sku delivery_and_return front_camera secondary_camera network_4g battery_capacity stock_status quantity low_stock_threshold specification_data video_preview_url video_title video_url short_description { html } description { html } promotions { start_date end_date } promotion_link promotion_tag_label display_low_stock_badge __typename general_description image { url label } small_image { url label } thumbnail { url label } media_gallery { url label position } attribute_set_id ... on PhysicalProductInterface { weight } price_range { minimum_price { regular_price { value currency } final_price { value currency } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } } attributes { label code value_index } } } ... on BundleProduct { dynamic_sku dynamic_price dynamic_weight price_view ship_bundle_items items { option_id title required type position sku options { id quantity position is_default price price_type can_change_quantity label product { id name quantity low_stock_threshold display_low_stock_badge sku __typename price_range { minimum_price { regular_price { value } } } } } } } related_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } upsell_products { name sku badges badges_swatch badges_label quantity stock_status __typename low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off } } } image { url label } } crosssell_products { name sku badges badges_swatch badges_label quantity low_stock_threshold display_low_stock_badge price_range { minimum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } maximum_price { regular_price { value } final_price { value } discount { amount_off percent_off } } } image { url label } } } } }`;

export const DealSelectionProductGQL = `
query products($id: String!) {
	products(filter: { sku: { eq: $id } }) {
		items {
			attribute_set_id
			name
			sku
			bundle_product_price
			__typename
			small_image {
				url
				label
			}
			categories {
				name
			}
			... on ConfigurableProduct {
				configurable_options {
					id
					attribute_id
					label
					attribute_code
					values {
						value_index
						label
						swatch_data {
							value
						}
					}
					product_id
				}
				variants {
					product {
						id
						name
						sku
						__typename
						small_image {
							url
							label
						}
						attribute_set_id
					}
					attributes {
						label
						code
						value_index
					}
				}
			}
		}
	}
}`;

export const ProductCarouselData = `query products($id: String!) {
	products(filter: { sku: { eq: $id } }) {
		items {
			name
			sku
			promotion_tag_swatch
			badges_swatch
			badges
			badges_label
			manufacturer
			quantity
			manufacturer_label
			promotion_tag_label
			stock_status
			low_stock_threshold
			display_low_stock_badge
			categories {
				id
				name
				url_key
				image
			}
			__typename
			description {
				html
			}
			meta_title
			meta_description
			price_range {
				minimum_price {
					regular_price {
						value
						currency
					}
					final_price {
						value
						currency
					}
					discount {
						amount_off
						percent_off
					}
				}
				maximum_price {
					regular_price {
						value
						currency
					}
					final_price {
						value
						currency
					}
					discount {
						amount_off
						percent_off
					}
				}
			}
			price_tiers {
				discount {
					amount_off
					percent_off
				}
				final_price {
					value
					currency
				}
				quantity
			}
			image {
				url
				label
			}
			small_image {
				url
				label
			}
			media_gallery {
				url
				label
				... on ProductVideo {
					video_content {
						media_type
						video_provider
						video_url
						video_title
						video_description
						video_metadata
					}
				}
			}
		}
	}
}`;

export const guestCreateEmptyCart = `mutation {
	createEmptyCart
}`;

export const guestAddSimpleProductToCart = `mutation addSimpleProductsToCart(
	$cart_id: String!
	$cart_items: [SimpleProductCartItemInput]!
) {
	addSimpleProductsToCart(
		input: { cart_id: $cart_id, cart_items: $cart_items }
	) {
		cart {
			items {
				id
				product {
					sku
					stock_status
					stock_item {
						min_qty
						min_sale_qty
						max_sale_qty
					}
					name
				}
				quantity
			}
			total_quantity
		}
	}
}`;

export const guestAddConfigurableProductToCart = `mutation addConfigurableProductsToCart(
	$cart_id: String!
	$cart_items: [ConfigurableProductCartItemInput]!
) {
	addConfigurableProductsToCart(
		input: {
			cart_id: $cart_id
			cart_items: $cart_items
		}
	) {
		cart {
			items {
				id
				quantity
				product {
					name
					sku
				}
				... on ConfigurableCartItem {
					configurable_options {
						id
						option_label
					}
				}
			}
			total_quantity
		}
	}
}`;

export const guestAddBundleProduct = `mutation addBundleProductsToCart(
	$cart_id: String!
	$cart_items: [BundleProductCartItemInput]!
) {
	addBundleProductsToCart(
		input: {
			cart_id: $cart_id
			cart_items: $cart_items
		}
	) {
		cart {
			items {
				id
				quantity
				product {
					sku
				}
				... on BundleCartItem {
					bundle_options {
						id
						label
						type
						values {
							id
							label
							price
							quantity
						}
					}
				}
			}
		}
	}
}`;

export const shippingAndBillingAddress = `query($cart_id: String!) {cart(cart_id: $cart_id) {email billing_address {customer_address_id firstname lastname address_type_name address_name region {region_id code label } country {code label } unit_number complex_name street_number street company city suburb postcode telephone instructions } shipping_addresses {customer_address_id firstname lastname address_type_name address_name region {region_id code label } country {code label } unit_number complex_name street_number street company city suburb postcode telephone instructions selected_shipping_method {amount {value currency } carrier_code carrier_title method_code method_title } } } }`;

export const guestViewCart = `query ($cart_id: String!) {
  cart(cart_id: $cart_id) {
    shippingMessageText {
      delivery_message
      free_shipping_message
      free_shipping_method_message
      standard_shipping_message
      standard_shipping_method_message
    }
    shipping_fee_calculate {
      method_code
      carrier_code
      shipping_label
      shipping_fee
    }
    cart_order_limits {
      cart_qty_limit
      order_value_limit
    }
    items {
      id
      parent_product_sku
      prices {
        row_total_original {
          value
        }
        row_total_including_tax {
          value
        }
        total_item_discount {
          value
        }
        price {
          value
        }
        discounts {
          label
          amount {
            value
          }
        }
      }
      product {
		... on ConfigurableProduct {
			configurable_options {
			  id
			  attribute_id
			  label
			  position
			  use_default
			  attribute_code
			  values {
				value_index
				label
				swatch_data {
				  value
				}
			  }
			  product_id
			}
			variants {
			  product {
				id
				name
				sku
				promotion_tag_label
				stock_status
				stock_item {
				  min_qty
				  min_sale_qty
				  max_sale_qty
				}
				attribute_set_id
				... on PhysicalProductInterface {
				  weight
				}
				small_image {
				  url
				  label
				}
				price_range {
				  minimum_price {
					regular_price {
					  value
					  currency
					}
					final_price {
					  value
					  currency
					}
					discount {
					  amount_off
					  percent_off
					}
				  }
				  maximum_price {
					regular_price {
					  value
					  currency
					}
					final_price {
					  value
					  currency
					}
					discount {
					  amount_off
					  percent_off
					}
				  }
				}
				quantity
				badges_label
				low_stock_threshold
				attribute_set_id
			  }
			  attributes {
				label
				code
				value_index
			  }
			}
		  }
        ... on BundleProduct {
          enable_click_and_collect
          items {
            option_id
            title
            options {
              id
              is_hidden_product
              is_default
              label
              quantity
              product {
                id
                name
                sku
                quantity
                primary_product_sku
                promo_data
                ... on ConfigurableProduct {
                  configurable_options {
                    id
                    attribute_id
                    attribute_code
                    label
                    values {
                      value_index
                      label
                      swatch_data {
                        value
                      }
                    }
                  }
                  variants {
                    product {
                      id
                      name
                      sku
                      stock_status
                      quantity
                      low_stock_threshold
                      image {
                        url
                        label
                      }
                      __typename
                    }
                    attributes {
                      label
                      code
                      value_index
                    }
                  }
                }
              }
            }
          }
        }
        ... on CustomizableProductInterface {
          options {
            option_id
          }
        }
        anytime_product_sku
        name
        id
        sku
        deal_delivery
        sim_only_flg
        promotion_tag_label
        low_stock_threshold
        quantity
        stock_status
        is_deal_product
        description {
          html
        }
        badges
        promo_data
        minutes
        minutes_label
        airtime
        old_monthly_recurring
        sms
        plan_name
        plan_name_label
        plan_type
        componentid
        contract_sku
        plan_type_label
        nightowl_units
        nightowl_uom
        contract_type
        contract_type_label
        payment_terms
        payment_terms_label
        badges_label
        promotion_tag
        promotion_tag_label
        promotion_link
        accessories
        accessories_label
        monthly_recurring
        primary_product_sku
        categories {
          id
          name
          level
          category_url
          description
        }
        primary_product_image
        primary_product_name
        stock_item {
          min_qty
          min_sale_qty
          max_sale_qty
        }
        categories {
          id
          name
        }
        eppixproductcode
        __typename
        image {
          url
          label
        }
        small_image {
          url
          label
        }
        ... on SimpleProduct {
          __typename
        }
      }
      ... on ConfigurableCartItem {
        configurable_options {
          id
          option_label
          value_id
          value_label
        }
        config_custom_options: customizable_options {
          id
          values {
            id
            label
            value
          }
        }
      }
      ... on BundleCartItem {
        bundle_custom_options: customizable_options {
          values {
            value
          }
        }
        customizable_options {
          label
          values {
            value
            label
          }
        }
        bundle_customisable_option {
          attribute_option_id
          selected_attribute
        }
      }
      quantity
    }
    available_payment_methods {
      code
      title
    }
    selected_payment_method {
      code
      title
    }
    applied_coupons {
      code
    }
    prices {
      discounts {
        amount {
          value
        }
        label
      }
      grand_total {
        value
        currency
      }
      subtotal_including_tax {
        value
        currency
      }
      subtotal_excluding_tax {
        value
        currency
      }
      subtotal_with_discount_excluding_tax {
        value
        currency
      }
      applied_taxes {
        amount {
          value
          currency
        }
        label
      }
      discounts {
        amount {
          value
        }
        label
      }
    }
    total_quantity
  }
}
`;

export const getAttributes = `query products($sku: String!){ products(filter: { sku: { eq: $sku } }) { items {attribute_set_id  internal_storage  internal_storage_label    battery_capacity battery_capacity_label color color_label screen_size_pixels_label screen_size_pixels} attribute_set_config{ attribute_set_id configurable_product_attribute_set_attributes configurable_product_attribute_set_label } }}`;

export const updateCartItems = `mutation updateCartItems(
	$cart_id: String!
	$cart_item_id: Int!
	$quantity: Float!
	$attributes: [SuperAttributeInput]
	$customizable_options: [CustomizableOptionInput]!
) {
	updateCartItems(
		input: {
			cart_id: $cart_id
			cart_items: [
				{
					cart_item_id: $cart_item_id
					quantity: $quantity
					super_attribute: $attributes
					customizable_options: $customizable_options
				}
			]
		}
	) {
		cart {
			items {
				id
				product {
					sku
					stock_status
					stock_item {
						min_qty
						min_sale_qty
						max_sale_qty
					}
					name
				}
				quantity
			}
			total_quantity
		}
	}
}`;

export const removeCartItems = `mutation removeItemFromCart($cart_id: String!, $cart_item_id: Int!) {
	removeItemFromCart(input: { cart_id: $cart_id, cart_item_id: $cart_item_id }) {
		cart {
			items {
				id
				product {
					sku
					name
				}
				quantity
			}
			total_quantity
		}
	}
}`;

export const generateCustomerToken = `mutation generateCustomerToken(
	$email: String!
	$password: String!
	) {
	  generateCustomerToken(
		email: $email
	 password: $password
	  ) {
		token
	  }
	}`;

export const setGuestEmailOnCart = `mutation setGuestEmailOnCart(
	$cart_id: String!
	$email: String!
	) {
		setGuestEmailOnCart(
			input: {
			  cart_id: $cart_id
			  email: $email
			}
		  ) {
			cart {
			  email
			}
		  }
	}`;

export const getAllCustomerAddressLists = `{
	customer {
		firstname
		lastname
		telephone
		suffix
		email
		addresses {
			id
			firstname
            lastname
            address_type_name
            address_name
            region {
                region_id
                region
                region_code
            }
            country_code
            unit_number
            complex_name
            street_number
            street
            company
            city
            suburb
            postcode
            telephone
            instructions
            default_shipping
			default_billing
			is_shipping_address
			is_billing_address
		}
	}
}`;

export const setNewBillingAddress = `mutation setBillingAddressOnCart(
	$cart_id: String!
	$firstname: String!
	$lastname: String!
	$company: String
	$instructions: String
	$street: [String]!
	$city: String!
	$region: String!
	$address_type_name: String!
	$address_name: String!
	$unit_number: String
	$complex_name: String
	$street_number: String
	$suburb: String!
	$postcode: String!
	$country_code: String!
	$telephone: String!
	$save_in_address_book: Boolean
	$is_shipping_address: Int!
	$is_billing_address: Int!
	$same_as_shipping: Boolean
) {
	setBillingAddressOnCart(
		input: {
			cart_id: $cart_id
			billing_address: {
				address: {
					firstname: $firstname
					lastname: $lastname
					company: $company
					instructions: $instructions
					street: $street
					city: $city
					region: $region
					address_type_name: $address_type_name
					address_name: $address_name
					unit_number: $unit_number
					complex_name: $complex_name
					street_number: $street_number
					suburb: $suburb
					postcode: $postcode
					country_code: $country_code
					telephone: $telephone
					save_in_address_book: $save_in_address_book
					is_shipping_address: $is_shipping_address
					is_billing_address: $is_billing_address
				}
				same_as_shipping: $same_as_shipping
			}
		}
	) {
		cart {
			billing_address {
				customer_address_id
				firstname
				lastname
                address_type_name
				address_name
                region {
					region_id
					code
					label
				}
                country {
					code
					label
				}
                unit_number
				complex_name
				street_number
                street
				company
				city
				suburb
				postcode
				telephone
				instructions
				is_shipping_address
				is_billing_address
			}
		}
	}
}`;

export const setExistingBillAddress = `mutation setBillingAddressOnCart(
	$cart_id: String!
	$customer_address_id: Int!
	$same_as_shipping: Boolean
) {
	setBillingAddressOnCart(
		input: {
			cart_id: $cart_id
			billing_address: { customer_address_id: $customer_address_id, same_as_shipping: $same_as_shipping}
		}
	) {
		cart {
			billing_address {
				customer_address_id
				firstname
				lastname
                address_type_name
				address_name
                region {
					region_id
					code
					label
				}
                country {
					code
					label
				}
                unit_number
				complex_name
				street_number
                street
				company
				city
				suburb
				postcode
				telephone
				instructions
				is_shipping_address
				is_billing_address
			}
		}
	}
}`;

export const setNewShippingAddress = `mutation setShippingAddressesOnCart(
	$cart_id: String!
	$firstname: String!
	$lastname: String!
	$company: String
	$instructions: String
	$street: [String]!
	$city: String!
	$region: String!
	$address_type_name: String!
	$address_name: String!
	$unit_number: String
	$complex_name: String
	$street_number: String
	$suburb: String!
	$postcode: String!
	$country_code: String!
	$telephone: String!
	$save_in_address_book: Boolean
	$is_shipping_address: Int!
) {
	setShippingAddressesOnCart(
		input: {
			cart_id: $cart_id
			shipping_addresses: [
				{
					address: {
						firstname: $firstname
						lastname: $lastname
						company: $company
						instructions: $instructions
						street: $street
						city: $city
						region: $region
						address_type_name: $address_type_name
						address_name: $address_name
						unit_number: $unit_number
						complex_name: $complex_name
						street_number: $street_number
						suburb: $suburb
						postcode: $postcode
						country_code: $country_code
						telephone: $telephone
						save_in_address_book: $save_in_address_book
						is_shipping_address: $is_shipping_address
					}
				}
			]
		}
	) {
		cart {
			shipping_addresses {
				customer_address_id
				firstname
				lastname
                address_type_name
				address_name
                region {
					region_id
					code
					label
				}
                country {
					code
					label
				}
                unit_number
				complex_name
				street_number
                street
				company
				city
				suburb
				postcode
				telephone
				instructions
				is_shipping_address
				is_billing_address
                selected_shipping_method {
                    amount {
                        value
                        currency
                    }
                    carrier_code
                    carrier_title
                    method_code
                    method_title
                }
			}
		}
	}
}`;

export const setExistingShippingAddress = `mutation setShippingAddressesOnCart(
	$cart_id: String!
	$customer_address_id: Int!
) {
	setShippingAddressesOnCart(
		input: {
			cart_id: $cart_id
			shipping_addresses: [{ customer_address_id: $customer_address_id }]
		}
	) {
		cart {
			shipping_addresses {
				customer_address_id
				firstname
				lastname
                address_type_name
				address_name
                region {
					region_id
					code
					label
				}
                country {
					code
					label
				}
                unit_number
				complex_name
				street_number
                street
				company
				city
				suburb
				postcode
				telephone
				instructions
				is_shipping_address
				is_billing_address
                selected_shipping_method {
                    amount {
                        value
                        currency
                    }
                    carrier_code
                    carrier_title
                    method_code
                    method_title
                }
			}
		}
	}
}`;

export const updateCustomerAddress = `mutation updateCustomerAddress(
	$id: Int!
	$region_id: Int!
	$region: String!
	$region_code: String!
	$company: String
	$instructions: String
	$street: [String]!
	$telephone: String!
	$postcode: String!
	$city: String!
	$address_type_name: String!
	$address_name: String!
	$unit_number: String
	$complex_name: String
	$street_number: String
	$suburb: String!
	$firstname: String!
	$lastname: String!
	$default_shipping: Boolean!
	$default_billing: Boolean!
	$is_shipping_address: Int!
	$is_billing_address: Int!
) {
	updateCustomerAddress(
		id: $id
		input: {
			region: { region_id: $region_id, region: $region, region_code: $region_code }
			country_code: ZA
			instructions: $instructions
			company: $company
			street: $street
			telephone: $telephone
			postcode: $postcode
			city: $city
			address_type_name: $address_type_name
			address_name: $address_name
			unit_number: $unit_number
			complex_name: $complex_name
			street_number: $street_number
			suburb: $suburb
			firstname: $firstname
			lastname: $lastname
			default_shipping: $default_shipping
			default_billing: $default_billing
			is_shipping_address: $is_shipping_address
			is_billing_address: $is_billing_address
		}
	) {
		id
		firstname
		lastname
        address_type_name
		address_name
		region {
			region_id
			region
			region_code
		}
        country_code
        unit_number
		complex_name
		street_number
		street
        company
		city
		suburb
        postcode
        telephone
        instructions
		default_shipping
		default_billing
		is_shipping_address
		is_billing_address
	}
}`;

export const createCustomerAddress = `mutation createCustomerAddress(
	$region_id: Int!
	$region: String!
	$region_code: String!
	$company: String
	$instructions: String
	$street: [String]!
	$telephone: String!
	$postcode: String!
	$city: String!
	$address_type_name: String!
	$address_name: String!
	$unit_number: String
	$complex_name: String
	$street_number: String
	$suburb: String!
	$firstname: String!
	$lastname: String!
	$default_shipping: Boolean!
	$default_billing: Boolean!
	$is_shipping_address: Int!
	$is_billing_address: Int!
) {
	createCustomerAddress(
		input: {
			region: { region_id: $region_id, region: $region, region_code: $region_code }
			country_code: ZA
			instructions: $instructions
			company: $company
			street: $street
			telephone: $telephone
			postcode: $postcode
			city: $city
			address_type_name: $address_type_name
			address_name: $address_name
			unit_number: $unit_number
			complex_name: $complex_name
			street_number: $street_number
			suburb: $suburb
			firstname: $firstname
			lastname: $lastname
			default_shipping: $default_shipping
			default_billing: $default_billing
			is_shipping_address: $is_shipping_address
			is_billing_address: $is_billing_address
		}
	) {
		id
		firstname
		lastname
        address_type_name
		address_name
		region {
			region_id
			region
			region_code
		}
        country_code
        unit_number
		complex_name
		street_number
		street
        company
		city
		suburb
        postcode
        telephone
        instructions
		default_shipping
		default_billing
		is_shipping_address
		is_billing_address
	}
}`;

export const getSAStates = `query {
    country(id: "ZA") {
        id
        full_name_english
        available_regions {
            id
            code
            name
        }
    }
}`;

export const getAddressTypes = `{
	addressType {
		allOptions{
		  id
		  label
		}
	}
  }`;

export const getCustomerActiveCart = `{
	customerCart {
	  id
	  items {
		id
		product {
		  name
		  sku
		}
		quantity
	  }
	}
  }`;

export const getDealSkus = `
   query products($name: String)
	{
		DealSelection (sku: $name)
		{
		deal_skus
		}
}`;

export const DealSelection = `
   query products($filter: ProductAttributeFilterInput,$sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {
	 products(
		 filter: $filter,
		 pageSize: $pageSize,
		 currentPage: $currentPage sort: $sort
	 ) {
		 total_count
		 page_info {
			 page_size
			 current_page
			 total_pages
		 }
		 items {
			name
			url_key
			sku
			promo_data
			minutes
			promotion_tag_swatch
			minutes_label
			airtime
			sms
			primary_product_image
			primary_product_sku
			contract_sku
			payment_terms
			payment_terms_label
			package_description
			promotion_tag
			promotion_tag_label
			monthly_recurring
			old_tariff
			old_installment
			old_monthly_recurring
			save_monthly_recurring
			stock_status
			deal_go_live_date
			deal_end_date
			deal_label
			is_deal_locked
			__typename
			image {
			  url
			}
			small_image {
			  url
			}
		  }
		 aggregations {
			attribute_code
			options {
			  label
			  value
			}
		 }
		 price_range {
			attribute_code
			min_value
			max_value
		  }
	 }
 }`;

export const getAttributeOptions = `query {
	 customAttributeMetadata(
	   attributes: [
		 {
		   attribute_code: "plan_type"
		   entity_type: "4"
		 }
		 {
		   attribute_code: "accessories"
		   entity_type: "4"
		 }
		 {
		   attribute_code: "plan_name"
		   entity_type: "4"
		 }
		 {
		   attribute_code: "contract_type"
		   entity_type: "4"
		 }
		 {
		   attribute_code: "promotion_tag"
		   entity_type: "4"
		 }
		 {
		   attribute_code: "payment_terms"
		   entity_type: "4"
		 }
	   ]
	 ) {
	   items {
		 attribute_code
		 attribute_type
		 attribute_options {
		  value
		  label
		  default
		}
	   }
	 }
	 contract_type_desc {
		contract_type_option_label
        contract_type_desc
	  }
   }`;

export const dealGrid = `query products( $search: String $filter: ProductAttributeFilterInput $sort: ProductAttributeSortInput $pageSize: Int $currentPage: Int ) { contract_type_desc { contract_type_option_label contract_type_desc } products( search: $search filter: $filter pageSize: $pageSize currentPage: $currentPage sort: $sort ) { total_count page_info { page_size current_page total_pages } items { name url_key sku promo_data minutes categories { id name level } promotion_tag_swatch minutes_label airtime sms primary_product_image primary_product_sku contract_sku payment_terms payment_terms_label package_description promotion_tag promotion_tag_label monthly_recurring old_tariff old_installment old_monthly_recurring save_monthly_recurring stock_status deal_go_live_date deal_end_date deal_label is_deal_locked __typename image { url } small_image { url } } aggregations { label attribute_code options { label value } } price_range { attribute_code min_value max_value } } }`;

export const setShippingMethodsOnCart = `mutation setShippingMethodsOnCart(
	$cart_id: String!,
	$carrier_code: String!,
	$method_code: String!
	){
	setShippingMethodsOnCart(
		input: {
		cart_id: $cart_id,
		shipping_methods: [
			{
			carrier_code: $carrier_code,
			method_code: $method_code
			}
		]
		}
	) {
		cart {
		shipping_addresses {
			selected_shipping_method {
			carrier_code
			carrier_title
			method_code
			method_title
			amount {
				value
				currency
			}
			}
		}
		}
	}
}`;

export const setPaymentMethodOnCart = `mutation setPaymentMethodOnCart(
	$cart_id: String!
	$payment_code: String!
){
	setPaymentMethodOnCart(input: {
		cart_id: $cart_id
		payment_method: {
			code: $payment_code
		}
	}) {
		cart {
		selected_payment_method {
			code
			title
		}
		}
	}
}`;

export const placeOrder = `mutation placeOrder(
		$cart_id: String!
	){placeOrder(
		  input: {
			cart_id: $cart_id
		  }
		) {
			order {
				order_number
				tracking_number
				courier_partner
				delivery_address
				contact_person
				payment_status
				grand_total
				customer_name
				customer_email
				items {
					image
					title
					price
					  qty
				  regular_price
				  configurable_options{
					id
					option_label
					value_id
					option_value
				  }
				  bundle_options {
							id
							label
							values {
								label
								price
								quantity
							}
						}
					}
				 invoice_url
				delivery_time_message
			}
		}
	}`;
export const BannerDetails = ` query banners($grid:String,$brand:String,$promotion:String){ banners(grid:$grid,brand:$brand,promotion:$promotion){ banner_image banner_icon_image banner_heading banner_heading_descriptions banner_url banner_mobile_image } }`;

export const AlertDetails = `
	query productAlert($productId:String){
		productAlert(productId:$productId){
		message
		}
	}`;

export const salesOrderDetail = `query salesOrder($id: String){
	salesOrder(id: $id) {
    increment_id
    customer_name
    grand_total
    order_type
    is_guest_customer
    created_at
    shipping_method
    customer_email
    tracking_number
    courier_partner
    delivery_address
    delivery_fee
    sim_only_flg
    contact_person
    payment_status
    order_status
    invoice_url
    delivery_time_message
    estimated_delivery_date
    waybill_number
    discount_amount
    cancel_order_duration_in_minutes
    ordered_product_details {
      product_details
    }
    journey_type
    vetting_result
    items {
      image
      title
      price
      qty
      primary_product_image
      vas_category_image
      description
      regular_price
      is_deal_product
      monthly_recurring
      parent_product_sku
			promo_data
      configurable_options{
        id
        option_label
        value_id
        option_value
        attribute_code
      }
      bundle_options {
        id
        label
        values {
          label
          price
          quantity
        }
      }
    }
	}
}`;

export const customerPreviousOrders = `query customerPlacedOrder($year: String, $sort: SortEnum, $pageSize: Int, $currentPage: Int ) {
	customerPlacedOrder (year: $year, order_id:"", sort:{ created_at:$sort }, pageSize: $pageSize, currentPage: $currentPage) {
		total_count
	}
}`;

export const customerPlacedOrder = `query customerPlacedOrder($order_id: String, $year: String, $sort: SortEnum, $pageSize: Int, $currentPage: Int ) {
	customerPlacedOrder ( year: $year, order_id:$order_id, sort:{ created_at:$sort }, pageSize: $pageSize, currentPage: $currentPage) {
		total_count
		page_info {
			page_size
				current_page
				total_pages
		}
		allOrderRecords{
			order_id
			increment_id
			customer_name
			grand_total
			monthly_recurring
			payment_terms
			payment_terms_label
			created_at
			shipping_method
			status
			estimated_delivery_date
			order_type
			image
			primary_product_image
			view_order_history
			cancel_order_duration_in_minutes
			waybill_number
		}
	}
}`;

export const AddCouponCode = `mutation applyCouponToCart($cart_id: String!, $coupon_code: String!) {
	applyCouponToCart(input: { cart_id: $cart_id, coupon_code: $coupon_code }) {
		cart {
			items {
				product {
					name
				}
				prices {
					total_item_discount {
						value
					}
					price {
						value
					}
					discounts {
						label
						amount {
							value
						}
					}
				}
				product {
					name
					sku
				}
				quantity
			}
			applied_coupons {
				code
			}
			prices {
			grand_total {
					value
					currency
				}
				subtotal_including_tax {
					value
					currency
				}
				subtotal_excluding_tax {
					value
					currency
				}

				subtotal_with_discount_excluding_tax {
					value
					currency
				}
				applied_taxes {
					amount {
						value
						currency
					}
					label
				}
				discounts {
					amount {
						value
					}
					label
				}
			}
		}
	}
}`;
export const DealDetail = `query products($url_key: [String]) {
	contract_type_desc {
	  contract_type_option_label
	  contract_type_desc
	}
	products(filter: { url_key: { in: $url_key } }) {
    items {
      id
	  url_key
	  deal_delivery
      name
      meta_title
      meta_description
      sku
	  contract_sku
      sim_only_flg
      categories {
      id
      name
      }
      promotion_tag
      promotion_tag_swatch
      badges_swatch
      badges
      promotion_link
      badges_label
      __typename
      delivery_message
      tariff
      installment
      old_installment
      old_tariff
      monthly_recurring
      old_monthly_recurring
      save_monthly_recurring
      stock_status
      payment_terms
      payment_terms_label
      primary_product_sku
      primary_product_image
      anytime_product_sku
      promotion_tag
      promotion_tag_description
      promotion_tag_label
      delivery_and_return
      promo_data
      nightowl_units
      nightowl_uom
      minutes
      minutes_label
      airtime
      sms
      plan_type_label
      plan_name_label
      contract_type_label
      contract_type
      voucher_url
      promotion_link
      internal_storage
      internal_storage_label
      battery_capacity_label
      color
      color_label
      stock_message {
      out_of_stock_title
      out_of_stock_description
      low_stock_title
      low_stock_description
      }
      image {
      url
      label
      }
      small_image {
      url
      label
      }
      media_gallery {
      url
      label
      }
      ... on CustomizableProductInterface {
      options {
      title
      required
      sort_order
      option_id
      __typename
      ... on CustomizableDropDownOption {
      title
      value {
      price_type
      option_type_id
      title
      sku
      }
      }
      }
      }
      ... on BundleProduct {
        enable_click_and_collect
        items {
          option_id
          title
          required
          type
          position
          sku
          options {
            id
            quantity
            position
            is_default
            price
            price_type
            is_hidden_product
            can_change_quantity
            label
            product {
              id
              name
              sku
              quantity
              stock_status
              primary_product_image
              promotion_link
              primary_product_sku
              promo_data
              nightowl_units
              nightowl_uom
              minutes
              minutes_label
              airtime
              sms
              badges
              visibility
              attribute_set_id
              badges_label
              promotion_tag_swatch
              badges_swatch
              color
              color_label
              size
              size_label
              screen_size_pixels_label
              internal_storage
              internal_storage_label
              battery_capacity_label
              manufacturer
              manufacturer_label
              __typename
              image {
                url
                label
              }
              ... on ConfigurableProduct {
                configurable_options {
                  id
                  attribute_id
                  label
                  position
                  use_default
                  attribute_code
                  values {
                    value_index
                    label
                    swatch_data {
                      value
                    }
                  }
                  product_id
                }
                variants {
                  product {
                    id
                    name
                    sku
                    stock_status
                    quantity
                    low_stock_threshold
                    image {  url label }
                    __typename
                    price_range {
                      minimum_price {
                        regular_price {
                          value
                          currency
                        }
                        final_price {
                          value
                          currency
                        }
                        discount {
                          amount_off
                          percent_off
                        }
                      }
                      maximum_price {
                        regular_price {
                          value
                        }
                        final_price {
                          value
                        }
                        discount {
                          amount_off
                          percent_off
                        }
                      }
                    }
                  }
                  attributes {
                    label
                    code
                    value_index
                  }
                }
              }
            }
          }
        }
      }
      related_products {
        name
        sku
        primary_product_image
        primary_product_sku
        promotion_tag_swatch
        badges_swatch
        badges
        badges_label
        quantity
        componentid
        url_key
        low_stock_threshold
        display_low_stock_badge
        plan_type_label
        plan_name_label
        promo_data
        nightowl_units
        nightowl_uom
        minutes
        minutes_label
        airtime
        sms
        payment_terms
        payment_terms_label
        tariff
        installment
        old_installment
        old_tariff
        monthly_recurring
        old_monthly_recurring
        save_monthly_recurring
      }
      upsell_products {
        name
        sku
        primary_product_image
        primary_product_sku
        promotion_tag_swatch
        badges_swatch
        badges
        badges_label
        quantity
        componentid
        contract_sku
        low_stock_threshold
        display_low_stock_badge
        plan_type_label
        plan_name_label
        promo_data
        nightowl_units
        nightowl_uom
        minutes
        minutes_label
        airtime
        sms
        payment_terms
        payment_terms_label
        tariff
        install
        old_installment
        old_tariff
        monthly_recurring
        old_monthly_recurring
        save_monthly_recurring
      }
      crosssell_products {
        name
        sku
        primary_product_image
        primary_product_sku
        promotion_tag_swatch
        badges_swatch
        badges
        badges_label
        quantity
        low_stock_threshold
        display_low_stock_badge
        plan_type_label
        plan_name_label
        promo_data
        nightowl_units
        nightowl_uom
        minutes
        minutes_label
        airtime
        sms
        componentid
        contract_sku
        payment_terms
        payment_terms_label
        tariff
        installment
        old_installment
        old_tariff
        monthly_recurring
        old_monthly_recurring
        save_monthly_recurring
      }
    }
	  attribute_set_config {
      attribute_set_id
      configurable_product_attribute_set_attributes
      configurable_product_attribute_set_label
	  }
	}
}`;

export const RelatedDeals = `query products($manufacturer: String) {
	products(
		filter: {
			manufacturer: { eq: $manufacturer }
			price: { from: "0.001", to: "9999999999" }
			is_deal_product: { eq: "0" }
			is_hidden_product: { eq: "0" }
			is_esd_product: { eq: "0"}
		}
		pageSize: 4
		currentPage: 1
	) {
		items {
			airtime
			url_key
			badges_label
			contract_sku
			deal_end_date
			deal_go_live_date
			deal_label
			id
			image {
        url
      }
			installment
			is_deal_locked
			meta_title
			meta_description
			minutes_label
			monthly_recurring
			name
			old_installment
			old_monthly_recurring
			old_tariff
			package_description
			payment_terms
			payment_terms_label
			primary_product_image
      primary_product_sku
			promo_data
			promotion_tag_label
			promotion_tag_swatch
			quantity
			save_monthly_recurring
			small_image {
				url
				label
			}
			sms
			sku
			tariff
		}
	}
}`;

export const DealSelectionDetail = `query products($contract_skus: [String]) { contract_type_desc { contract_type_option_label contract_type_desc } products(filter: { url_key: { in: $contract_skus} }) { items { id name categories{ id name } promotion_tag promotion_tag_swatch badges_swatch badges promotion_link badges_label __typename eppixproductcode delivery_message tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring stock_status payment_terms payment_terms_label primary_product_sku primary_product_image anytime_product_sku promotion_tag promotion_tag_description promotion_tag_label delivery_and_return promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms plan_type_label plan_name_label contract_type_label contract_type voucher_url promotion_link internal_storage internal_storage_label battery_capacity_label color color_label stock_message { out_of_stock_title out_of_stock_description low_stock_title low_stock_description } image { url label } small_image{ url label } media_gallery { url label } ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title sku } } } } ... on BundleProduct { enable_click_and_collect items { option_id title required type position sku options { id quantity position is_default price price_type is_hidden_product can_change_quantity label product { id name sku quantity stock_status primary_product_image promotion_link primary_product_sku promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms badges visibility attribute_set_id badges_label promotion_tag_swatch badges_swatch color color_label size size_label screen_size_pixels_label internal_storage internal_storage_label battery_capacity_label __typename image { url label } } } } } related_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity componentid contract_sku low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms payment_terms payment_terms_label tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } upsell_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity componentid contract_sku low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data nightowl_units nightowl_uom minutes minutes_label airtime sms payment_terms payment_terms_label tariff install old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } crosssell_products { name sku primary_product_image primary_product_sku promotion_tag_swatch badges_swatch badges badges_label quantity low_stock_threshold display_low_stock_badge plan_type_label plan_name_label promo_data  nightowl_units nightowl_uom minutes minutes_label airtime sms componentid contract_sku payment_terms payment_terms_label tariff installment old_installment old_tariff monthly_recurring old_monthly_recurring save_monthly_recurring image { url label } categories { id name url_key image } ... on BundleProduct { items { option_id title sku options { id label product { id name sku quantity __typename } } } } } } attribute_set_config{ attribute_set_id configurable_product_attribute_set_attributes configurable_product_attribute_set_label } } }`;

export const persistCart = `query {
	persist_cart{
		persistent_enable
		persistent_lifetime
		persistent_logout_clear
	}
}`;

export const removeCouponCode = `mutation removeCouponFromCart($cart_id: String!) {
	removeCouponFromCart(input: { cart_id: $cart_id }) {
		cart {
			items {
				product {
					name
				}
				quantity
			}
			applied_coupons {
				code
			}
			prices {
				grand_total {
					value
					currency
				}
			}
		}
	}
}`;

export const getGraphQlOperationFromRequestQuery = (requestQuery) => {
  var mySubString = "operation_name";

  //if starts with query
  if (requestQuery?.trim().startsWith("query")) {
    requestQuery = requestQuery?.substr(requestQuery?.indexOf("{") + 1).trim();
    mySubString = requestQuery?.substr(0, requestQuery?.indexOf("("));
  }
  //start with mutation
  else if (requestQuery?.trim().startsWith("mutation")) {
    requestQuery = requestQuery?.substr(requestQuery?.indexOf("{") + 1).trim();
    if (requestQuery?.indexOf("(") == -1) {
      var endIndex =
        requestQuery?.indexOf(" ") == -1
          ? requestQuery?.indexOf("}")
          : requestQuery?.indexOf(" ");
      mySubString = requestQuery?.substr(0, endIndex);
    } else {
      mySubString = requestQuery?.substr(0, requestQuery?.indexOf("("));
    }
  }
  //starts with a {
  else if (requestQuery?.trim().startsWith("{")) {
    requestQuery = requestQuery?.substr(requestQuery?.indexOf("{") + 1).trim();
    mySubString = requestQuery?.substr(0, requestQuery?.indexOf("{"));
    mySubString = mySubString.replace(/[():$_{}]/g, " ");
    mySubString = mySubString.trim();
  }
  return mySubString;
};

export const recommmendedDeals = `
   query products($filter: ProductAttributeFilterInput,$sort:ProductAttributeSortInput, $pageSize: Int, $currentPage: Int) {
	 products(
		 filter: $filter,
		 pageSize: $pageSize,
		 currentPage: $currentPage sort: $sort
	 ) {
		 total_count
		 page_info {
			 page_size
			 current_page
			 total_pages
		 }
		 items {
			 name
			 url_key
			 sku
			 primary_product_image
            primary_product_sku
			 badges
			 promo_data
			 minutes
			 minutes_label
			 airtime
			 sms
			 componentid
      		 contract_sku
			 plan_name
			 plan_name_label
			 package_description
			 plan_type
			 plan_type_label
			 contract_type
			 contract_type_label
			 payment_terms
			 payment_terms_label
			 badges_label
			 manufacturer
			 manufacturer_label
			 promotion_tag
			 promotion_tag_label
			 accessories
			 accessories_label
			 monthly_recurring
			 old_tariff
			 old_installment
			 old_monthly_recurring
			 save_monthly_recurring
			 stock_status
			 low_stock_threshold
			 display_low_stock_badge
			 deal_go_live_date
			 deal_end_date
			 deal_label
			 is_deal_locked
			 server_time
			 categories {
				id
				name
			}
			 __typename
			 image {
				 url
				 label
			 }
			 small_image {
				 url
				 label
			 }
			 ... on BundleProduct {
				items {
				  option_id
				  title
				  sku
				  options {
					id
					label
					product {
					  id
					  name
					  sku
					  quantity
					  __typename
					}
				  }
				}
			  }
		 }
		 sort_fields {
			 default
			 options {
				 label
				 value
			 }
		 }
		 price_range {
			attribute_code
			min_value
			max_value
		  }
	 }
 }`;

export const dealGridAggregations = `query products($filter: ProductAttributeFilterInput,$sort: ProductAttributeSortInput,$pageSize: Int,$currentPage: Int) {
	products(filter: $filter,pageSize: $pageSize,currentPage: $currentPage,sort: $sort) { aggregations {label attribute_code options {label value}}}}`;

export const productAggregations = `query products($filter: ProductAttributeFilterInput,$sort: ProductAttributeSortInput,$pageSize: Int,$currentPage: Int)
{
	products(filter:$filter, currentPage: $currentPage, pageSize: $pageSize, sort: $sort)
	{ aggregations{ label attribute_code options{ label value }  } }
}`;
//  is_pre_selected
export const vasProductQuery = `name is_pre_selected sku promotion_link description { html } stock_status image { url label } categories { id name image level category_url } ... on CustomizableProductInterface { options { title required sort_order option_id ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } }`;

export const vasProductAddOrRemoveInCart = `mutation addRemoveCartItems($cart_id: String!, $remove_simple_products: [String], $cart_items: [BundleProductCartItemInput]!)
{
	addRemoveCartItems(input: { cart_id: $cart_id, remove_simple_products: $remove_simple_products, cart_items: $cart_items})
	{
	  cart {
		items {
		  id
		  quantity
		  product {
			sku
		  }
		  ... on BundleCartItem {
			bundle_options {
			  id
			  label
			  type
			  values {
				id
				label
				price
				quantity
			  }
			}
			customizable_options {
			  id
			  label
			  values {
				id
				value
			  }
			}
		  }
		}
	  }
	}
  }`;

export const getAll5GRouters = `{
  products(
    filter: { whitelisted_flag: { eq: "1" },
      is_deal_product : {eq : "0"},
    }
    currentPage: 1
    sort: { name: ASC }
  ) {
    total_count
    items {
      id
	  url_key
      sku
      whitelisted_flag
      attribute_set_id
      name
      image {
        url
        label
      }
      price_range {
        minimum_price {
          regular_price {
            value
            currency
          }
          final_price {
            value
            currency
          }
        }
      }
    }
  }
}`;
